import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  deleteContribution,
  openEditContributionDialog
} from '../../../../../../stores/discussion/discussion.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getContribution } from '../../../../../../stores/discussion/discussion.selectors'

const mapStateToProps = (state, { id, contributionId }) => {
  const contribution = getContribution(state, id)
  return {
    id: contributionId,
    body:
      contribution &&
      contribution.action_object &&
      contribution.action_object.content
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onDelete: () =>
    dispatch(deleteContribution(ownProps.contributionId, ownProps.id)).catch(
      errorHandler
    ),
  onOpenEditContributionDialog: body =>
    dispatch(
      openEditContributionDialog(ownProps.contributionId, ownProps.id, body)
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContextMenu)
